

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

define(function (require, exports, module) {

    var envi = require('c-nenv');
    var Url = require('c-url');
    var Base = require('c-base');

    var Wechat = Base.extend({

        defaults: {
            appid: 'wx78a12cd5f3b2a993'
        },

        originMap: {
            // stage: 'http://awsbj-webapi.xingyunzhi.cn',
            stage: 'https://webapi.upliveapp.com',
            pro: 'https://webapi.upliveapp.com'
        },

        // oauth域名配置
        openHostMap: {
            stage: 'http://awsbj-openapi.xingyunzhi.cn',
            pro: 'https://openapi.pengpengla.com'
        },

        initialize: function initialize() {
            var self = this;
            // console.log(envi.platform)
            // 非微信，不下载微信的sdk
            if (!envi.platform.isWeixin) {
                return;
            }

            if (typeof wx !== 'undefined') {
                return;
            }

            var _script = $('<script></script>');
            _script.attr('src', 'http://h.cdn.pengpengla.com/h5lib/3.0.0/js/jweixin-1.0.0.js');

            setTimeout(function () {
                $(document.head).append(_script);
            });

            _script.on('load', function (e) {

                self.getSign(self.get('appid')).done(function (json) {
                    if (json.errcode == 0) {
                        self.setWxConfig(json);
                    }
                });
            });
        },
        /**
         * 设置微信权限配置
         */
        setWxConfig: function setWxConfig(json) {
            var self = this;
            var data = json.data || {};
            self.validHosts = json.data.list || [];
            data.jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'hideOptionMenu', 'showOptionMenu', 'chooseWXPay'];
            setTimeout(function () {
                // data.debug = true; 打开微信的debug
                wx.config(data);
                self.afterConfig();
            }, 400);
        },

        /**
         * 获取签名信息
         */
        getSign: function getSign(wechatAppId) {
            // 加签的URL不能带HASH
            var url = location.href;
            if (url.indexOf('#') != -1) {
                url = url.substr(0, url.indexOf('#'));
            };

            var params = {
                url: url
            };

            if (wechatAppId) {
                params.appId = wechatAppId;
            }

            var ajaxUrl = (this.originMap[Url.query('env')] || this.originMap['pro']) + '/wechat-share-sign/get';

            var promise = $.ajax({
                url: ajaxUrl,
                type: 'GET',
                data: params
            });

            return promise;
        },

        // 根据游戏的appid获取微信配置信息
        getWechatInfoByAppId: function getWechatInfoByAppId(appId) {
            var _$$ajax;

            var origin = this.openHostMap[Url.query('env')] || this.openHostMap['pro'];
            var url = origin + '/sns/get-wechat-app-id';

            var promise = $.ajax((_$$ajax = {
                url: url,
                type: 'GET',
                dataType: 'json'
            }, _defineProperty(_$$ajax, 'url', url), _defineProperty(_$$ajax, 'data', {
                appId: appId
            }), _$$ajax));

            promise.done(function (res) {
                if (res.errcode) {
                    // 页面异常
                    console.error('content', res.errmsg + '(' + res.errcode + ')');
                }
            });

            return promise;
        },

        afterConfig: function afterConfig() {
            var self = this;
            // 通过ready接口处理成功验证
            wx.ready(function () {
                self.ready = true;
                // 配置完立马使用，在该事件中设置新的分享文本，非立马使用，可以直接setData
                self.emit('ready');
            });
            // 通过error接口处理失败验证
            wx.error(function (res) {
                console.log('wx error', res);
                self.emit('error');
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });
        }

    });

    module.exports = new Wechat();
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/c-up-wechat/dist/index.js
// module id = 335
// module chunks = 0 1